import { createSlice } from '@reduxjs/toolkit';
import ApiClientConnector from 'src/api/ApiClientConnector';

const initialState = {
    searchCriteria: {
        destination: null,
        checkIn: null,
        checkOut: null,
        countryCode: null,
    },
    paxRoomData: [{ adults: 2, children: 0, childrenAges: [] }],
    wedding: false,
    honeymoon: false,
    provider: null,
    maxAdult: 4,
    maxChildren: 4,
    hotels: [],
    searchRequestId: 0,
    sessionId: null,
    selectedCountry: null,
};

export const SearchHotelSlice = createSlice({
    name: 'searchHotel',
    initialState,
    reducers: {
        setHotelSearchCriteria: (state, action) => {
            state.searchCriteria = { ...state.searchCriteria, ...action.payload };
        },
        clearHotelSearchCriteria: (state) => {
            state.searchCriteria = initialState.searchCriteria;
        },
        updatePaxRoomData: (state, action) => {
            state.paxRoomData = action.payload;
        },
        updateAdultsCount: (state, action) => {
            const { index, count } = action.payload;
            if (state.paxRoomData[index]) {
                state.paxRoomData[index].adults = count;
            }
        },
        updateChildrenCount: (state, action) => {
            const { index, count } = action.payload;
            const room = state.paxRoomData[index];

            if (room) {
                room.children = count;

                if (count > room.childrenAges.length) {
                    room.childrenAges = [...room.childrenAges, ...Array(count - room.childrenAges.length).fill(0)];
                } else {
                    room.childrenAges = room.childrenAges.slice(0, count);
                }
            }
        },
        updateChildrenAges: (state, action) => {
            const { index, childIndex, age } = action.payload;
            const room = state.paxRoomData[index];

            if (room && room.childrenAges[childIndex] !== undefined) {
                room.childrenAges[childIndex] = age;
            }
        },
        setWedding: (state, action) => {
            state.wedding = action.payload;
        },
        setHoneymoon: (state, action) => {
            state.honeymoon = action.payload;
        },
        setMaxAdult: (state, action) => {
            state.maxAdult = action.payload;
        },
        setMaxChildren: (state, action) => {
            state.maxChildren = action.payload;
        },
        paxIncrement: (state, action) => {
            const { index, type } = action.payload;
            const room = state.paxRoomData[index];

            if (type === 'adults' && room.adults < state.maxAdult) {
                room.adults += 1;
            } else if (type === 'children' && room.children < state.maxChildren) {
                room.children += 1;
                room.childrenAges.push(0);
            }
        },

        paxDecrement: (state, action) => {
            const { index, type } = action.payload;
            const room = state.paxRoomData[index];

            if (type === 'adults' && room.adults > 1) {
                room.adults -= 1;
            } else if (type === 'children' && room.children > 0) {
                room.children -= 1;
                room.childrenAges.pop();
            }
        },
        getHotelResultList: (state, action) => {
            state.hotels = action.payload;
        },
        incrementSearchRequestId: (state) => {
            state.searchRequestId += 1;
        },
        setCountry: (state, action) => {
            state.selectedCountry = action.payload;
        },
        setSearchSessionId: (state, action) => {
            state.sessionId = action.payload;
        },
    },
});


export const fetchHotels = (instance, accounts, criteria) => async (dispatch) => {
    dispatch(incrementSearchRequestId());
    const client = await ApiClientConnector(instance, accounts);
    const result = await client.hotels.post(criteria);
    dispatch(setSearchSessionId(result.SessionId));
    const hotelsArray = result.Results || [];
    dispatch(getHotelResultList(hotelsArray));
    return result;
};

export const {
    setHotelSearchCriteria,
    clearHotelSearchCriteria,
    updatePaxRoomData,
    updateAdultsCount,
    updateChildrenCount,
    updateChildrenAges,
    setWedding,
    setHoneymoon,
    setMaxAdult,
    setMaxChildren,
    paxIncrement,
    paxDecrement,
    getHotelResultList,
    incrementSearchRequestId,
    setCountry,
    setSearchSessionId
} = SearchHotelSlice.actions;

export default SearchHotelSlice.reducer;
